/**
 * Paths available to users who are not logged in
 * @constant
 */
export const PUBLIC_PATHS = {
  LANDING: "/",
  LOGIN: "/login",
};

/**
 * Paths available to users who are  logged in
 * @constant
 */
export const PROTECTED_PATHS = {
  DASHBOARD: "/dashboard",
  VTU: "/vtu",
  VTU_TRANSACTIONS_HISTORY: "/vtu/transactions-history",
  VTU_CUSTOMER_CARE: "/vtu/customer-care",
  BUY_WATER: "/buy-water",
  PAYMENT_RECORDS: "/payments",
  USAGE: "/usage",
  PROFILE: "/profile",
  MESSAGES: "/messages",
  CLEAR_TAMPER: "/clear-tamper",
  NOTIFICATION: "/notification",
  FAQ: "/faq",
  LOGIN: "/login",
};

export const DATA_ROWS = {
  LIMIT: 6,
};
